import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FormControl, IconButton, InputAdornment, MenuItem, Select } from '@mui/material';
import { ClearIcon } from "@mui/x-date-pickers";
import { useStyles } from './DropdownStyles';
import {useLocation} from "react-router-dom";

const Dropdown = ({
  value,
  onChangeFn = (value) => {},
  options = [],
  withDebounce = false,
  debounceDelay = 500,
  onDebounceStart = () => {},
  onDebounceEnd = () => {},
  placeHolder = 'Sort by:',
  widthString = '200px',
  backgroundColor = ''
}) => {
  const [dropdownValue, setDropdownValue] = useState(value || '');
  const debounceTimeout = useRef(null);
  const location = useLocation();

  const debounce = (func, delay) => {
    return (...args) => {
      onDebounceStart();
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(async () => {
        await func(...args);
        onDebounceEnd();
      }, delay);
    };
  };

  useEffect(() => {
    setDropdownValue(value);
  }, [value]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setDropdownValue(newValue);

    if (!withDebounce) {
      onChangeFn(newValue);
    } else {
      debouncedChange(newValue);
    }
  };

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChangeFn(newValue);
    }, debounceDelay),
    [onChangeFn, debounceDelay]
  );

  return (
    <FormControl variant="filled" sx={useStyles.formControl(widthString, backgroundColor)}>
      <Select
        value={dropdownValue}
        onChange={handleChange}
        sx={useStyles.select}
        startAdornment={
          <InputAdornment sx={useStyles.startAdornment} position="start">
            {placeHolder}
          </InputAdornment>
        }
        endAdornment={
          dropdownValue && (
            <InputAdornment sx={useStyles.endAdornment} position="end">
              <IconButton
                onClick={() => {
                  setDropdownValue('');
                  withDebounce && debouncedChange('');
                }}
              >
                <ClearIcon sx={useStyles.clearIcon}></ClearIcon>
              </IconButton>
            </InputAdornment>
          )
        }
      >
        {options.map((option) => (
          <MenuItem sx={useStyles.menuItem} key={option.value} value={option.value} disabled={option.value === 1 && location.pathname === '/home'}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
